import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { deleteParamColumnOrderToShare } from '../../ultils';
import './applied-filter.scss';
import applierFilterAtom from '../../recoils/useApplierFilter/applierFilterAtom';
import { useRecoilState } from 'recoil';

interface IProps {
  appliedFilters: string[];
  onRemoveFilter: (removeFilterName: string) => void;
  onRemoveAllFilter: () => void;
  isOrderByColumn: boolean;
  setIsOrderByColumn: (stat: boolean) => void;
  columnApi?: any;
  updateUrl: (suffixUrl: string) => void;
  currentUrl: string;
}

const AppliedFilter: React.FC<IProps> = (props) => {
  // ! for language
  const { t } = useTranslation();
  const {
    appliedFilters,
    onRemoveFilter,
    onRemoveAllFilter,
    isOrderByColumn,
    setIsOrderByColumn,
    columnApi,
    updateUrl,
    currentUrl
  } = props;
  const [appliedFilterList, setAppliedFilterList] = useState<string[]>([]);
  const [, setAppliedFilter] = useRecoilState(applierFilterAtom);

  useEffect(() => {
    if (appliedFilters) {
      setAppliedFilterList(appliedFilters);
      setAppliedFilter(appliedFilters);
    }
  }, [appliedFilters]);

  const removeAllHandler = () => {
    setIsOrderByColumn(false);
    // ! if exists filter list
    if (appliedFilterList.length > 0) {
      onRemoveAllFilter();
      deleteParamColumnOrderToShare(currentUrl, updateUrl);
    }
    columnApi?.resetColumnState();
  };

  const removeFilterHandler = (event: any) => {
    const filterName = event.target.getAttribute('data-filter');
    // ! if filterRemoved is Column Order filter
    if (filterName === 'Column Order') {
      setIsOrderByColumn(false);
      columnApi?.resetColumnState();
      deleteParamColumnOrderToShare(currentUrl, updateUrl);
    }
    onRemoveFilter(filterName);
  };

  return (
      <div className="applied-filter-container">
        <div className="applied-filter-header">
          <p>
            <strong>{t('xref-applied-filters')}</strong>
          </p>
          <button
            className="remove-all-btn"
            id="remove-all-btn"
            onClick={removeAllHandler}
          >
            {t('xref-remove-all')}
          </button>
        </div>
        <div className="applied-filter-box">
          {isOrderByColumn && (
            <div className="applied-filter">
              Column Order
              <span
                className="icon-close"
                id="remove-filter-btn"
                onClick={removeFilterHandler}
                title="Click to remove this filter"
                data-filter="Column Order"
              ></span>
            </div>
          )}

          {appliedFilterList.map((element: any) => (
            <div className="applied-filter" key={element}>
              {element}
              <span
                className="icon-close"
                id="remove-filter-btn"
                onClick={removeFilterHandler}
                title="Click to remove this filter"
                data-filter={element}
              ></span>
            </div>
          ))}
        </div>
      </div>
  );
};

export default AppliedFilter;
